<template>
	<div style="background: #f2f2f2;" v-show="show">
		<common-head active="1" state="1"></common-head>

		<div class="info">
			<div class="name">
				{{info.page_title}}
			</div>
			<div class="content" v-html="info.page_content"></div>
		</div>

		<common-footer></common-footer>
	</div>
</template>

<script>
    import { site_name } from '@/static/js/common.js';
	import commonHead from '@/components/wap/commonHead.vue';
	import commonFooter from '@/components/wap/commonFooter.vue';
	import { common_page } from '@/api/common.js';
	export default {
		name: 'page',
		components: {
			commonHead, commonFooter
		},
		data() {
			return {
				info: {page_title:'页面'},
				show:false,
			}
		},
		metaInfo() {
			site_name().then(res => {
                document.title = this.info.page_title + '-' + res.site_name;
                return {
                    title: this.info.page_title + '-' + res.site_name,
                    meta: [
                        { name: "keywords", content: "" },
                        { name: "description", content: "" },
                        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' }
                    ],
                }
            });
		},
		created() {
			const id = this.$route.query.id;
			this.get_data(id);
		},
		methods: {
			get_data(id) {
				common_page({id:id}).then(res=>{
					if(res.code==1){
						this.info = res.data;
						this.show = true;
					}
				});
			},
		},
	}
</script>
<style scoped>
	.info {
		width: calc(100% - 30px);
		margin: 15px;
		margin-top: 20px;
		margin-bottom: 20px;
		background: #fff;
	}

	.name {
		text-align: center;
		font-size: 28px;
		font-weight: 700;
		line-height: 100px;
		color: #a0ca32;
	}

	.other {
		text-align: center;
		margin-bottom: 30px;
	}

	.other span {
		margin-right: 30px;
		color: #666;
		font-weight: 300;
	}

	.content {
		line-height: 1.5;
		padding: 15px;
	}

	/deep/ .content img{
		max-width: calc(100% - 30px)!important;
		text-align: center!important;
	}
</style>